<template>
    <div class="svg-icon">

        <svg xmlns="http://www.w3.org/2000/svg"
            class="svg-inline--fa fa-lock-alt fa-w-15 fill-current"
            :viewBox=viewBox
			:alt="`${name} icon`"
            :class="[`fa-${size}`, classNames]"
            role="presentation"
        >
            <title lang="en"> icon</title>
                <g class="fill-current">
                    <component 
                        ref="svg-icon"
                        :is="Icon" />
                </g>
        </svg>
        
        <p><slot /></p>
    </div>
</template>

<script>
    
export default {
    props: {
        'Icon': {}, 
        'size': {
            type: String,
            default: ""   
        }, 
        'classNames': {},
        editStroke: {
            type: Boolean, 
            default: false
		},
        fill: {
            type: Boolean,
            default: true,
		},
		name: {
			type: String,
			default: '',
		}
    },
    data() {
        return {
            viewBox: "0 0 20 18"
        }
    },
    mounted() {
        const icon = this.$refs['svg-icon'].$el;
        const viewBox = icon.viewBox;
        if (viewBox) {
            const iconVB = viewBox.baseVal;
            this.viewBox = `${iconVB.x} ${iconVB.y} ${iconVB.width} ${iconVB.height}`;
		}
		if (icon.firstChild) {
			if (this.fill) {
				icon.firstChild.style.fill = "currentColor";
			}
			if (this.editStroke) {
				icon.firstChild.style.stroke = "currentColor";
			}
		}
        if (icon.children) {
            let children = [...icon.children]
            for (let child of children) {
                if (child && child.style && this.fill) {
                    child.style.setProperty ("fill", "currentColor", "important")
                    if (this.editStroke) {
                        child.style.setProperty ("stroke", "currentColor", "important")
                        child.style.setProperty ("strokeWidth", "1", "important")
                    }
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '@fortawesome/fontawesome/styles.css';

    .svg-icon svg path,  .svg-icon svg stroke {
        fill: currentColor !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/SvgIcon.vue